import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _ProductLocationCatalog } from "../../../core/services/dataBean/EntityCatalogVdos";
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { BasicButton } from "../../theme/Component/BasicButton";


interface Props {
    Product: number;
}

export const ProductLocationCatalog = ({ Product }: Props) => {

    const location = useDataBean(_ProductLocationCatalog);
    const [IDStore, setIDStore] = useState<number>(null)
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDStore])

    const getLista = () => {

        location.instance.getProductLocationCatalog(Product, IDStore).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        location.setBean({
            IDProduct: Product,
            IDStore: IDStore
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {


    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        location.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProductLocation', visible: true },
        { title: 'Almacén', property: 'StoreName', visible: true },
        { title: 'Código de Estante', property: 'Code', visible: true },
        { title: 'Nombre de Estante', property: 'Name', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <p>Debe Seleecionar un Almacén*</p>
            <div className="col-md-6">

                <SelectStoreEditor label="Almacén" idSelector={IDStore} onChange={(e) => { setIDStore(e.IDStore) }} />

            </div>
            {/* <div className="col-md-6 mt-4">
                <BasicButton value="Consultar Tabla" icon="ri-play-list-add-fill" eventClick={getLista} ></BasicButton>
            </div> */}
            <div className="col-md-12">
                {IDStore &&
                    <>
                        <BasicTable body={lista} head={head} rowSet={location.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    </>
                }

                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        {/* <div className="col-md-12">
                        <SelectStoreEditor idSelector={location.bean.IDStore} onChange={(e) => { location.setBean({ ...location.bean, "IDStore": e }) }} />
                        </div> */}
                        <div className="col-md-6">
                            <label>Código Estante</label>
                            <input type="text" name="Code" className="form-control" value={location.bean.Code} onChange={location.handleChange} />
                            {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                        </div>
                        <div className="col-md-6">
                            <label>Nombre Estante</label>
                            <input type="text" name="Name" className="form-control" value={location.bean.Name} onChange={location.handleChange} />
                            {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                        </div>

                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={location.bean.Description} onChange={location.handleChange} />
                        </div>
                        {/* <PrintJson json={SubMacroProcess.bean} /> */}
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}